// Google Analytics 4 — activates only when REACT_APP_GA4_ID is set at build time.
// Also handles gsc site verification meta tag via REACT_APP_GSC_VERIFICATION.

const GA_ID = process.env.REACT_APP_GA4_ID || "";
const GSC_TOKEN = process.env.REACT_APP_GSC_VERIFICATION || "";

let initialized = false;

export const isGAEnabled = () => Boolean(GA_ID);

export function initGA() {
  if (initialized || !GA_ID || typeof window === "undefined") return;

  // Inject gtag script
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // Anonymize IP & disable Google Signals by default for privacy alignment
  gtag("config", GA_ID, {
    anonymize_ip: true,
    allow_google_signals: false,
    send_page_view: true,
  });

  // GSC verification via meta tag (fallback path — you can also verify via DNS)
  if (GSC_TOKEN) {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "google-site-verification");
    meta.setAttribute("content", GSC_TOKEN);
    document.head.appendChild(meta);
  }

  initialized = true;
}

export function trackPageview(path) {
  if (!initialized || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized || !window.gtag) return;
  window.gtag("event", name, params);
}
